var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaintroller = function SvgPaintroller(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 87 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.558 49.333v-6.387a1.163 1.163 0 0 0-.855-1.12L1.755 31.007A2.325 2.325 0 0 1 0 28.813V12.264a2.327 2.327 0 0 1 2.325-2.326h4.562v2.699H2.654v15.802l44.001 11.105a2.061 2.061 0 0 1 1.557 1.998v7.79h-2.654Z",
    fill: "#E1DFDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.887 12.642v8.405a2.195 2.195 0 0 0 2.193 2.195h75.587a2.193 2.193 0 0 0 2.194-2.195V2.195A2.196 2.196 0 0 0 84.666 0H9.08a2.193 2.193 0 0 0-2.193 2.195v10.447Z",
    fill: "#B06148"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.559 49.344h-2.742a1.535 1.535 0 0 0-1.536 1.536v50.325a1.518 1.518 0 0 0 .95 1.405c.186.075.385.112.586.109h8.225a1.532 1.532 0 0 0 1.536-1.514V50.88a1.559 1.559 0 0 0-1.536-1.536H45.56Z",
    fill: "#647F7F"
  })));
};
export default SvgPaintroller;